/**
 * Settings → Feature Customization。
 * 打开页面打 STATSIG.COMMON.VIEW，value=settings_feature_customization；Management 同组件 value=mgmt_feature_customization。
 *
 * 模块 FEATURE_CUSTOM = Feature Customization（CUSTOM 是 Customization 缩写）。
 * AUTO_PRE_QUAL = Auto Generate Pre-Qual Letter。
 * AUTO_DOC_REMINDER = Auto-Reminder for Documents。
 *
 * 正在用：Pre-Qual 开关立刻落库；Documents 提醒关掉立刻落库，打开开关后在弹窗点 Save；
 * 点 Edit 开弹窗，Save 记 UPDATE。
 * 已不算：Cancel、打开弹窗不存、确认弹窗、进页自动补默认配置。
 * Management 非 Owner 侧边栏是同一组件，不跨到 MGMT。
 */
export enum SettingsFeatureCustomizationEvent {
    /**
     * Auto Generate Pre-Qual Letter 开关。
     * 属性 enabled=true|false
     */
    AUTO_PRE_QUAL_SWITCH = 'FEATURE_CUSTOM_AUTO_PRE_QUAL_SWITCH',
    /**
     * Auto-Reminder for Documents 开关落库。
     * 属性 enabled=true|false
     */
    AUTO_DOC_REMINDER_SWITCH = 'FEATURE_CUSTOM_AUTO_DOC_REMINDER_SWITCH',
    /**
     * 点 Edit 打开提醒设置弹窗。
     * value 与 metadata.type 相同：click_open_popup
     */
    AUTO_DOC_REMINDER_BUTTON = 'FEATURE_CUSTOM_AUTO_DOC_REMINDER_BUTTON',
    /** Edit 弹窗点 Save 落库 */
    AUTO_DOC_REMINDER_UPDATE = 'FEATURE_CUSTOM_AUTO_DOC_REMINDER_UPDATE',
}
